import getCustomListContent from './get-content';
import removeButtonProcessingState from '../../universal/button-state/remove-button-processing-state';
import activateCloudinaryImages from '../../universal/cloudinary/activate';

/*******************************************************************************
TRIGGER GET CUSTOM LIST CONTENT
Trigger appending more custom list content to the page.
*******************************************************************************/

export default async function triggerGetCustomListContent(e) {
    const $button = $(e.currentTarget);
    const listID = $button.data('list');
    const lastContent = $button.data('last');
    const listType = $button.data('type');
    const style = $button.data('style');
    let excludedContentIDs = [];
    if (listType === 'auto') {
        excludedContentIDs = $button.parents('.custom-list').find(`.custom-list__item[data-last="${lastContent}"]`).map((i, el) => $(el).data('item')).get();
    }

    const { contentHTML, newLastContent, haveMoreContent } = await getCustomListContent(listID, listType, lastContent, excludedContentIDs, style);

    // Add the articles to the page
    const $articleList = $button.prevAll('.article-list');

    if ($articleList.length > 0) {
        $articleList.append(contentHTML);
    }
    else {
        $button.before(contentHTML);
    }


    // Load the images
    activateCloudinaryImages();

    if (haveMoreContent) {
        // Update the button's "last" data attribute
        $button.data('last', newLastContent);

        // Reset the button to its original state
        removeButtonProcessingState($button);
    }
    else {
        $button.after('<p class="light">There are no more articles to display.</p>').remove();
    }
}
